import { SidebarModalListItem, Text } from '@domain-group/suit-theme'

import useActivity from '@hooks/useActivity'

import { renderActionText } from '@functions/activity'

import type { ActivityModel } from '@models/types'

interface ActivityProps {
  activity: ActivityModel,
}

const Activity = (props: ActivityProps) => {
  const { activity } = props

  const activityPayload = useActivity(activity)

  const {
    activity: { owner },
    callbacks: { manageActivity },
    formattedDateShort,
    isDestructive,
  } = activityPayload

  return (
    <SidebarModalListItem
      boxProps={{ paddingX: 'medium' }}
      secondaryText={`${owner?.title} - ${formattedDateShort}`}
      title={<Text color={isDestructive ? 'red' : 'green'} fontSize="small">{renderActionText(activity)}</Text>}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <SidebarModalListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <SidebarModalListItem.Icon
          onClick={() => manageActivity()}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </SidebarModalListItem.Actions>
    </SidebarModalListItem>
  )
}

export default Activity
